import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: 'How does PRINTLY work?',
      answer: 'Simply scan the QR code on the kiosk, upload your document from your phone, select print options (B&W or Color), make payment, and collect your prints instantly.'
    },
    {
      question: 'Can I schedule prints for later?',
      answer: 'Yes! PRINTLY allows you to schedule prints in advance. Upload your document, pay online, and pick up your prints at your convenience.'
    },
    {
      question: 'What file types are supported?',
      answer: 'PRINTLY supports PDF, DOCX, JPG, PNG, and most common document and image formats.'
    },
    {
      question: 'How do I make payment?',
      answer: 'We accept UPI, credit/debit cards, and popular digital wallets. All payments are secure and encrypted.'
    },
    {
      question: 'Is PRINTLY available 24/7?',
      answer: 'Yes, PRINTLY kiosks are available round-the-clock wherever they\'re installed, giving you printing access anytime you need it.'
    },
    {
      question: 'What paper sizes do you support?',
      answer: 'Currently, PRINTLY supports A4 and A5 paper sizes for both black & white and color printing.'
    },
    {
      question: 'Do I need to install an app?',
      answer: 'No app installation required! Just scan the QR code with your phone\'s camera to access the web-based interface.'
    },
    {
      question: 'How much does printing cost?',
      answer: 'Pricing varies by location and print type. Rates are displayed on the kiosk screen before you confirm your print job.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-2xl mb-6">
              <HelpCircle className="w-8 h-8 text-yellow-600" />
            </div>
            <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wide">FAQ</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-6">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-gray-600">
              Got questions? We've got answers. Find everything you need to know about PRINTLEY.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg border-2 border-gray-100">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-white rounded-xl border-2 border-gray-100 px-6 hover:border-yellow-200 transition-colors duration-200"
                >
                  <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-yellow-600 py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-5 pt-2">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Bottom Help Section */}
          <div className="mt-12 text-center bg-yellow-50 rounded-2xl p-8 border-2 border-yellow-100">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Still have questions?
            </h3>
            <p className="text-gray-600 mb-6">
              Our support team is here to help. Reach out and we'll get back to you within 24 hours.
            </p>
            <button 
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold px-8 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:scale-105"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
